<template>
  <with-loader :id="id" :loading="loading" class="table-list h-full" v-bar>
    <div class="p-1 pr-4">
      <t-table
        :headers="columnNames"
        :data="data"
        :responsive="true"
        variant="loading"
      >
        <template #tbody="{ data, tdClass, trClass, rowIndex,tbodyClass }">
          <tbody :class="tbodyClass">
          <tr v-for="(row, i) in data"
              :key="i"
              :class="[trClass, { 'bg-soft text-black-soft': selectedRowIndex === i }]"
              class="table-row table"
              @click="$emit('click', i)"
          >
            <slot name="td" :tdClass="tdClass" :row="row"/>
          </tr>
          </tbody>
        </template>
      </t-table>
    </div>
  </with-loader>
</template>

<script>
import WithLoader from '@/components/common/WithLoader'

export default {
  name: 'LoadingTable',

  components: {
    WithLoader
  },

  props: {
    id: {
      type: String,
      default: 'table'
    },
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    columnNames: {
      type: Array,
      required: true
    },
    selectedRowIndex: {
      type: Number,
      default: 0
    }
  }
}
</script>
